import {ChangeDetectorRef, Directive, Input} from '@angular/core';
import {ContextService, DataBindingDirective, GridComponent, GridDataResult, LocalDataChangesService, RowReorderService} from '@progress/kendo-angular-grid';
import {State} from '@progress/kendo-data-query';


//Directive de liaison des données de la grille
//  Reprend kendoGridBinding — tri, regroupement et pagination locaux — et ne retire que le
//  filtrage local quand le serveur a déjà filtré. Kendo comparerait sinon l’instant exact d’une
//  date avec heure au jour choisi dans le filtre (minuit), et écarterait des lignes retenues par
//  le serveur.
@Directive (
{
  selector: '[valGrilleBinding]',
  exportAs: 'valGrilleBinding'
})
export class GrilleBindingDirective extends DataBindingDirective
{
  //Création
  //  Paramètres
  //    grid                    : Grille Kendo
  //    changeDetector          : Détection des changements
  //    localDataChangesService : Service des changements de données locales
  //    rowReorderService       : Service de réordonnancement des lignes
  //    ctx                     : Contexte de la grille
  constructor (grid: GridComponent, changeDetector: ChangeDetectorRef, localDataChangesService: LocalDataChangesService,
               rowReorderService: RowReorderService, ctx: ContextService)
  {
    super (grid, changeDetector, localDataChangesService, rowReorderService, ctx);

    this.filtrageServeur = false;
  }

  //Données
  @Input ()
  public set valGrilleBinding (donnees: any[])
  {
    this.data = donnees;
  }

  //Indique si les données reçues sont déjà filtrées par le serveur
  @Input ()
  public filtrageServeur: boolean;

  //Traite les données selon l’état de la grille
  //  Paramètres
  //    state : État de la grille
  //  Retourne
  //    Données à afficher
  protected override process (state: State) : GridDataResult
  {
    return super.process (this.filtrageServeur ? {...state, filter: undefined} : state);
  }
}
